export const expenseNumber = ({ theme: { dimensions } }) => ({
    width: '100%',
    maxWidth: dimensions.inputMediumMaxWidth,
    marginBottom: dimensions.inputRowGap,
});
